import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
    CheckCircle as CheckCircleIcon,
    Warning as WarningIcon
} from '@mui/icons-material';
import './AcknowledgementStatus.css';

export const AcknowledgementSuccess = () => (
    <Box className="status-page-container">
        <Paper className="status-card-paper" elevation={3}>
            <Box className="status-icon-container">
                <CheckCircleIcon className="status-icon-success" />
            </Box>
            <Typography variant="h6" className="status-title">
                Policy Acknowledged Successfully
            </Typography>
            <Typography variant="body1" className="status-message">
                All the policy document(s) has been acknowledged.
            </Typography>
        </Paper>
    </Box>
);

export const AlreadyAcknowledged = () => (
    <Box className="status-page-container">
        <Paper className="status-card-paper" elevation={3}>
            <Box className="status-icon-container">
                <CheckCircleIcon className="status-icon-success" />
            </Box>
            <Typography variant="h6" className="status-title">
                Policy Already Acknowledged
            </Typography>
            <Typography variant="body1" className="status-message">
                You have already acknowledged all the policy document(s). No further action is required.
            </Typography>
        </Paper>
    </Box>
);

export const TokenExpired = () => (
    <Box className="status-page-container">
        <Paper className="status-card-paper" elevation={3}>
            <Box className="status-icon-container">
                <WarningIcon className="status-icon-warning" />
            </Box>
            <Typography variant="h6" className="status-title">
                Token Expired
            </Typography>
            <Typography variant="body1" className="status-message">
                Your session has ended. Please request a new link from your administrator to
                continue the policy acknowledgment.
            </Typography>
        </Paper>
    </Box>
);

export const TokenInvalid = () => (
    <Box className="status-page-container">
        <Paper className="status-card-paper" elevation={3}>
            <Typography variant="h6" className="status-title">
                Invalid Link ❌
            </Typography>
            <Typography variant="body1" className="status-message">
                This link is invalid. Please contact your administrator to request a new link.
            </Typography>
        </Paper>
    </Box>
);
